import React, { useEffect } from 'react';
import VenuesHeader from '../components/venues/VenuesHeader';
import VenuesHero from '../components/venues/VenuesHero';
import VenuesVideo from '../components/venues/VenuesVideo';
import VenuesFeatures from '../components/venues/VenuesFeatures';
import VenuesHowItWorks from '../components/venues/VenuesHowItWorks';
import VenuesPricing from '../components/venues/VenuesPricing';
import VenuesContact from '../components/venues/VenuesContact';
import Footer from '../components/Footer';

const Venues = () => {
  useEffect(() => {
    document.title = 'Tenku para canchas';
    return () => {
      document.title = 'Tenku';
    };
  }, []);

  return (
    <div className="bg-gray-900 min-h-screen">
      <VenuesHeader />
      <main>
        <VenuesHero />
        <VenuesVideo />
        <VenuesFeatures />
        <VenuesHowItWorks />
        <VenuesPricing />
        <VenuesContact />
      </main>
      <Footer />
    </div>
  );
};

export default Venues;
